// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @16/01/2024 14:49:33
import { PersistentObject } from '../../../SagaBase/PersistentObject';

export abstract class ListUnitTypes_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ListObjects.ListUnitTypes';
  $t: string = 'SagaSchema.ListObjects.ListUnitTypes';

  public static GetMembers(): string[] {
    return ['TypeName', 'Id', 'Icon', 'IsDefault'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ListUnitTypes_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public TypeName: string;
  public Id: number = 0;
  public Icon: any[];
  public IsDefault: boolean = false;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
